module.exports = __webpack_public_path__ + "img/qtum.2aa8fb8e.svg";